import api from './authService';

// ===========================================
// Types
// ===========================================

export interface EmailSettings {
  enabled: boolean;
  smtp_host: string | null;
  smtp_port: number;
  smtp_user: string | null;
  smtp_password_set: boolean;
  from_address: string | null;
  from_name: string | null;
  use_tls: boolean;
}

export interface EmailSettingsUpdate {
  enabled: boolean;
  smtp_host?: string;
  smtp_port: number;
  smtp_user?: string;
  smtp_password?: string;
  from_address?: string;
  from_name?: string;
  use_tls: boolean;
}

export interface CompanySettings {
  name: string | null;
  address: string | null;
  tel: string | null;
  email: string | null;
}

export interface BankSettings {
  bank_name: string | null;
  branch_name: string | null;
  account_type: string | null;
  account_number: string | null;
  account_holder: string | null;
}

export interface EmailTemplates {
  invoice: {
    subject: string;
    body: string;
  };
  payment: {
    subject: string;
    body: string;
  };
}

// ===========================================
// Email Settings API
// ===========================================

export const getEmailSettings = async (): Promise<EmailSettings> => {
  const response = await api.get<EmailSettings>('/admin/settings/email');
  return response.data;
};

export const updateEmailSettings = async (settings: EmailSettingsUpdate): Promise<{ message: string }> => {
  const response = await api.put('/admin/settings/email', settings);
  return response.data;
};

export const sendTestEmail = async (toEmail: string): Promise<{ message: string }> => {
  const response = await api.post('/admin/settings/email/test', { to_email: toEmail });
  return response.data;
};

// ===========================================
// Company Settings API
// ===========================================

export const getCompanySettings = async (): Promise<CompanySettings> => {
  const response = await api.get<CompanySettings>('/admin/settings/company');
  return response.data;
};

export const updateCompanySettings = async (settings: CompanySettings): Promise<{ message: string }> => {
  const response = await api.put('/admin/settings/company', settings);
  return response.data;
};

// ===========================================
// Bank Settings API
// ===========================================

export const getBankSettings = async (): Promise<BankSettings> => {
  const response = await api.get<BankSettings>('/admin/settings/bank');
  return response.data;
};

export const updateBankSettings = async (settings: BankSettings): Promise<{ message: string }> => {
  const response = await api.put('/admin/settings/bank', settings);
  return response.data;
};

// ===========================================
// Email Templates API
// ===========================================

export const getEmailTemplates = async (): Promise<EmailTemplates> => {
  const response = await api.get<EmailTemplates>('/admin/settings/email/templates');
  return response.data;
};

export const updateEmailTemplate = async (
  templateType: 'invoice' | 'payment',
  subject: string,
  body: string
): Promise<{ message: string }> => {
  const response = await api.put('/admin/settings/email/templates', {
    template_type: templateType,
    subject,
    body,
  });
  return response.data;
};
